<div class="consists-of-step1">
  <span>
    {{
      'TRANS__NEW_MODAL__CONSISTS_OF__INGRESS' | translate: {
        parentName: data().fieldParameters.sectionsContainer.rootObject.artifact_name,
        maxCount: maxCopies()
      }
    }}
  </span>

  <div class="consists-of-step1__options">
    <div class="consists-of-step1__option-container">
      <span class="bold">
        {{ 'TRANS__NEW_MODAL__SELECT_OBJECT_TYPE_NEW' | translate }}
      </span>

      <mat-form-field
        appearance="outline"
        class="consists-of-step1__type-field"
      >
        <mat-select
          class="consists-of-step1__select"
          [disabled]="selectedAction() !== 'new_object'"
          [value]="selectedObjectType()"
          (selectionChange)="selectObjectType(findObjectTypeByValue($event.value))"
        >
          @for (objectType of selectObjectTypes(); track $index) {
            @if (objectType.name) {
              <mat-option
                class="consists-of-step1__select-option"
                [value]="objectType.objectType"
              >
                {{ objectType.name }}
              </mat-option>
            }
          }
        </mat-select>
      </mat-form-field>
    </div>

    <div class="consists-of-step1__option-container">
      <span class="bold">
        {{ 'TRANS__NEW_MODAL__TARGET_OBJECT_COUNT' | translate }}
      </span>

      <mat-form-field
        appearance="outline"
        class="consists-of-step1__count-field"
      >
        <input
          type="number"
          min="1"
          [max]="maxCopies()"
          matInput
          [(ngModel)]="numberOfCopies"
          (change)="selectTargetCount()"
        />
      </mat-form-field>
    </div>
  </div>

  <div
    class="consists-of-step1__option-container"
  >
    <span class="bold">
      {{ 'TRANS__NEW_MODAL__COPY_FROM_EXISTING' | translate }}
    </span>

    <mat-radio-group
      class="consists-of-step1__radio-group"
      [value]="'new_object'"
    >
      <mat-radio-button
        [checked]="selectedAction() === 'new_object'"
        [value]="'new_object'"
        (click)="selectAction('new_object')"
        (keydown)="null"
      >
        {{ 'TRANS__NEW_MODAL__DONT_COPY_FIELDS' | translate }}
      </mat-radio-button>

      <mat-radio-button
        [checked]="selectedAction() === 'copy_from_parent'"
        [value]="'copy_from_parent'"
        (click)="selectAction('copy_from_parent')"
        (keydown)="null"
      >
        {{ 'TRANS__NEW_MODAL__COPY_FIELDS_FROM_PARENT' | translate }}
      </mat-radio-button>

      <mat-radio-button
        [checked]="selectedAction() === 'copy_from_other'"
        [value]="'copy_from_other'"
        (click)="selectAction('copy_from_other')"
        (keydown)="null"
      >
        {{ 'TRANS__NEW_MODAL__COPY_FIELDS_FROM_SELECTED_OBJECT' | translate }} {{ `TRANS__OBJECT_TYPE__${data().fieldParameters.sectionsContainer.rootObject.object_type.toUpperCase()}` | translate }}
      </mat-radio-button>
    </mat-radio-group>
  </div>
</div>
